import React, { Component } from "react";
import SimpleDDL from "../../../../modules/SimpleDDL";
import FlexView from "react-flexview";

class InfoUnitInputs extends Component {
  constructor(props) {
    super(props);
    this.viewOnly = props.activity === "VIEW";
  }

  render() {
    return (
      <div>
        <h4>Info Unit</h4>
        <SimpleDDL
          id="select_options_kode_varian"
          name="variantCode"
          label="Kode Varian"
          box="search"
          mandatory={!this.viewOnly}
          readOnly={this.viewOnly}
          errorMessage={this.props.errors?.variantCode}
          options={this.props.state?.kodeVarianOptions}
          value={this.props.data?.variantCode}
          onChange={this.props.onChangeVarian}
          // onChange={this.handleChangeVarian}
        />
        <FlexView column className="margin-bottom-15px" style={{ gap: "10px" }}>
          <p>Nama Varian: {this.props.state?.varianInformation.name}</p>
          <p>Tipe: {this.props.state?.varianInformation.type}</p>
          <p>Series: {this.props.state?.varianInformation.series}</p>
        </FlexView>
        <SimpleDDL
          id="select_options_warna"
          box="search"
          name="idWarna"
          label="Warna"
          mandatory={!this.viewOnly}
          options={this.props.state?.warnaOptions}
          readOnly={!this.props.data?.variantCode || this.viewOnly}
          errorMessage={this.props.errors?.idWarna}
          value={this.props.data?.idWarna}
          onChange={this.props.onChangeWarna}
        />
      </div>
    );
  }
}

export default InfoUnitInputs;
